import React from 'react';
import { Button } from './ui/button';
import { Shield, ArrowRight, Phone } from 'lucide-react';

const CTASection = ({ openPopup }) => {
  return (
    <section className="cta-section" id="cta">
      <div className="cta-overlay"></div>
      <div className="cta-background">
        <img 
          src="https://images.pexels.com/photos/5668806/pexels-photo-5668806.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
          alt="Professional legal team"
          className="cta-bg-image"
        />
      </div>
      
      <div className="cta-container">
        <div className="cta-content">
          <div className="cta-badge">
            <Shield size={20} />
            <span>Limited Time Offer</span>
          </div>
          
          <h2 className="cta-title">
            Protect Your Brand Today
          </h2>
          
          <p className="cta-description">
            Don't wait until it's too late. Secure your trademark rights now and safeguard 
            your brand's future. Join 1,000+ businesses who trust us with their trademark 
            registration. Get started with a free consultation and discover how affordable 
            brand protection can be.
          </p>

          <div className="cta-features-list">
            <div className="cta-feature">
              <div className="cta-feature-icon">✓</div>
              <span>Free Initial Consultation</span>
            </div>
            <div className="cta-feature">
              <div className="cta-feature-icon">✓</div>
              <span>98% USPTO Approval Success Rate</span>
            </div>
            <div className="cta-feature">
              <div className="cta-feature-icon">✓</div>
              <span>Dedicated Case Manager Assigned</span>
            </div>
            <div className="cta-feature">
              <div className="cta-feature-icon">✓</div>
              <span>Same-Day Application Review</span>
            </div>
          </div>

          <div className="cta-buttons">
            <Button onClick={openPopup} className="cta-primary-button" size="lg">
              Protect My Brand Now
              <ArrowRight size={20} />
            </Button>
            <a href="tel:+11231234567" className="cta-phone-button">
              <Phone size={20} />
              <span>Call: +1 (123) 123-4567</span>
            </a>
          </div>

          <div className="cta-urgency">
            <p>⚡ <strong>Act Fast:</strong> First-come, first-served in trademark registration. 
            Secure your rights before someone else does.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
